var queryString = require('query-string');

module.exports = function(string) {
    var parsed = queryString.parse(location.search);
    return parsed && parsed[string] ? parsed[string] : '';
};


// WEBPACK FOOTER //
// ./resources/scripts/helpers/query.js